import { Space } from 'antd';
import SelectFilter from '../../../components/ui/filters/SelectFilter';
import PrimaryButton from '../../../components/ui/PrimaryButton';
import { DownloadOutlined } from '@ant-design/icons';
import React, { useEffect, useState } from 'react';
import { useFetchData } from '../../../hooks';
import { BaseModel, PageableResponse } from '../../../types';
import { Resource } from '../../../lib/enums';
import { useSearchParams } from 'react-router-dom';
import DateRangeSelector from '../../../components/ui/filters/DateRangeFilter';

const VendorPerformanceHeaderFilter = ({
  startDate,
  endDate,
  handleExport,
}: {
  startDate: string | undefined | null;
  endDate: string | undefined | null;
  handleExport: () => void;
}) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const [selectedVendorValue, setSelectedVendorValue] = useState<
    string | undefined
  >(searchParams.get('vendorId') || '');

  const { data: vendorData, isLoading: isVendorLoading } = useFetchData<
    PageableResponse<BaseModel>
  >('/partner/vendors', {
    resource: Resource.MIN,
    search: '',
    length: '999999',
  });

  const handleVendorChange = (value: string) => {
    setSearchParams((prev) => {
      prev.set('vendorId', value);
      return prev;
    });
    setSelectedVendorValue(value);
  };

  useEffect(() => {
    if (
      !isVendorLoading &&
      vendorData !== null &&
      vendorData?.data !== undefined
    ) {
      if (
        searchParams.get('vendorId') === null &&
        searchParams.get('vendorId') === undefined
      ) {
        setSelectedVendorValue(vendorData?.data[0].id);
        setSearchParams((prev) => {
          prev.set('vendorId', vendorData.data[0]?.id);
          return prev;
        });
      }
    }
  }, [isVendorLoading]);

  return (
    <>
      <div className={'flex p-4 justify-between'}>
        <Space>
          <label htmlFor="location">Date Coverage:</label>
          <DateRangeSelector startDate={startDate} endDate={endDate} />
          <label htmlFor="location">Vendor:</label>
          <SelectFilter
            showSearch={true}
            defaultValue={selectedVendorValue}
            isLoading={isVendorLoading}
            dataOptions={vendorData?.data.map((item) => ({
              value: item.id,
              label: `${item.code} - ${item.description}`,
            }))}
            handleChange={handleVendorChange}
          />
        </Space>
        <PrimaryButton
          icon={<DownloadOutlined />}
          onClick={handleExport}
          label={'Export'}
        />
      </div>
    </>
  );
};

export default VendorPerformanceHeaderFilter;
